module.exports = __webpack_public_path__ + "img/wyfw.abbfeac2.png";